import { DEFAULT_NUMBER_OF_RECORDS } from "components/customTable/constants";

export const getInitialPageState = (fileName, fromCookie = false) => {
  return fromCookie && JSON.parse(window.localStorage.getItem(`${fileName}PageState`)) || {
    skip: 0,
    take: DEFAULT_NUMBER_OF_RECORDS,
  };
}
